import { Shield, CheckCircle, Users, HeadphonesIcon } from "lucide-react";

const TrustRibbon = () => {
  return (
    <div className="w-full bg-gradient-to-r from-primary via-primary-foreground/10 to-primary py-2 px-3 md:py-3 md:px-6">
      <div className="container mx-auto flex flex-col md:flex-row justify-between items-start md:items-center gap-2 md:gap-3">
        <div className="space-y-0.5 md:space-y-1">
          <div className="flex items-center gap-1.5 md:gap-2 flex-wrap">
            <Shield className="w-3.5 h-3.5 md:w-4 md:h-4 text-accent shrink-0" />
            <span className="font-semibold text-primary-foreground text-xs md:text-sm">
              Neil AI Global Solutions LLC
            </span>
            <span className="text-primary-foreground/80 hidden sm:inline">•</span>
            <span className="text-primary-foreground/90 text-[10px] md:text-sm hidden sm:inline">
              Verified AI & Robotics Automation Provider
            </span>
          </div>
          <p className="text-[9px] md:text-xs text-primary-foreground/75 hidden md:block">
            Serving real businesses, schools, churches & organizations across North Carolina and beyond.
          </p>
        </div>
        
        <div className="flex flex-wrap gap-1.5 md:gap-2">
          <span className="inline-flex items-center gap-1 px-2 py-1 md:px-3 md:py-1.5 rounded-full border border-accent/40 bg-background/10 backdrop-blur-sm text-[9px] md:text-xs text-primary-foreground">
            <span className="w-1.5 h-1.5 md:w-2 md:h-2 rounded-full bg-green-500 animate-pulse shadow-[0_0_8px_rgba(74,222,128,0.7)]" />
            SSL Secured
          </span>
          <span className="inline-flex items-center gap-1 px-2 py-1 md:px-3 md:py-1.5 rounded-full border border-accent/40 bg-background/10 backdrop-blur-sm text-[9px] md:text-xs text-primary-foreground">
            <CheckCircle className="w-2.5 h-2.5 md:w-3 md:h-3" />
            Verified Business
          </span>
          <span className="inline-flex items-center gap-1 px-2 py-1 md:px-3 md:py-1.5 rounded-full border border-accent/40 bg-background/10 backdrop-blur-sm text-[9px] md:text-xs text-primary-foreground hidden sm:inline-flex">
            <Users className="w-2.5 h-2.5 md:w-3 md:h-3" />
            Official Robotics Dealer
          </span>
          <span className="inline-flex items-center gap-1 px-2 py-1 md:px-3 md:py-1.5 rounded-full border border-accent/40 bg-background/10 backdrop-blur-sm text-[9px] md:text-xs text-primary-foreground hidden sm:inline-flex">
            <HeadphonesIcon className="w-2.5 h-2.5 md:w-3 md:h-3" />
            Human Support & Training
          </span>
        </div>
      </div>
    </div>
  );
};

export default TrustRibbon;
